import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import { getUserId } from '../../helpers/auth'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { Button, Input, Modal, Select } from 'antd'
import Loader from '../../pages/pages/loader'
import CustomersDropdown from '../CustomersDropdown'
import { useCreateM3uResponseMessageMutation, useUpdateM3uResponseMessageMutation } from '../../redux/apis/linkManagement/m3u/lmM3uResponseMessagesApiSlice'

const EditCreateM3uResponse = ({ state, open, setOpen, record }) => {
  const [
    update,
    { isLoading: isUpdating, isSuccess: SuccessUpdate, error: errorUpdate }
  ] = useUpdateM3uResponseMessageMutation()
  const [
    create,
    { isLoading: isAdding, isSuccess: SuccessAdd, error: errorAdd }
  ] = useCreateM3uResponseMessageMutation()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      message:record?.message,
      message_type:record?.message_type,
      last_updated_by: getUserId()
    },

    validationSchema: Yup.object({
      message: Yup.string().required('Please Enter Message'),
      message_type: Yup.string().required('Please select Message Type'),
    }),

    onSubmit: async values => {
      const formData = new FormData()
      for (let key in values) {
        formData.append(key, values[key])
      }

      try {
        if (state === 'edit') {
          await update({
            body: formData,
            id: record?.id
          }).unwrap()
        } else if (state === 'create') {
          await create(formData).unwrap()
        }
      } catch (err) {
        console.error(err)
      }
    }
  })

  useEffect(() => {
    if (errorAdd?.data) {
      const errorMessages = Object.values(errorAdd.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    } else if (errorUpdate?.data) {
      const errorMessages = Object.values(errorUpdate.data).flat()
      errorMessages.forEach(message => {
        toast.error(message)
      })
    }
  }, [errorAdd, errorUpdate])

  useEffect(() => {
    console.log(SuccessAdd, SuccessUpdate)
    if (SuccessAdd && state === 'create') {
      toast.success('M3U Response created successfully!')
      setOpen(false)
    } else if (SuccessUpdate && state === 'edit') {
      toast.success('M3U Response successfully!')
      setOpen(false)
    }
  }, [state, SuccessAdd, SuccessUpdate])

  return (
    <Modal
      className='customModal'
      open={open}
      title={state === 'edit' ? `Edit M3U Response` : 'Create M3U Response'}
      onCancel={() => setOpen(false)}
      footer={[
        <Button key='back' onClick={() => setOpen(false)}>
          Cancel
        </Button>,
        <Button
          key='submit'
          type='primary'
          onClick={() => {
            if (Object.keys(validation.errors).length !== 0) {
              Object.keys(validation.errors).map(key => {
                toast.error(validation.errors[key])
              })
              return
            }
            validation.handleSubmit()
          }}
        >
          Submit
        </Button>
      ]}
    >
      <Loader isLoading={isAdding || isUpdating} />
      
      <div className=' mb-3'>
        <label className="form-label">Message</label>
        <Input
          type='text'
          name='message'
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.message}
        />
        {validation.touched.message && validation.errors.message ? (
          <p className='text-danger'>{validation.errors.message}</p>
        ) : null}
      </div>
      <div className=' mb-3 flex-1'>
        <label>Message Type</label>
        <br />
        <Select
          className={''}
          name='message_type'
          style={{
            width: '100%'
          }}
          defaultValue={validation?.values?.message_type}
          value={validation?.values?.message_type}
          onChange={e => validation.setFieldValue('message_type', e)}
          onBlur={validation.handleBlur}
          options={[
            {
              label: 'Down',
              value: 'down'
            },
            {
              label: 'Check Again',
              value: 'check_again'
            }
          ]}
        />
        {validation.touched.message_type && validation.errors.message_type ? (
          <p className='text-danger'>{validation.errors.message_type}</p>
        ) : null}
      </div>
    </Modal>
  )
}

export default EditCreateM3uResponse
